import { render, staticRenderFns } from "./distributeList.vue?vue&type=template&id=03ea9e01&"
import script from "./distributeList.vue?vue&type=script&lang=js&"
export * from "./distributeList.vue?vue&type=script&lang=js&"
import style0 from "./distributeList.vue?vue&type=style&index=0&id=03ea9e01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports